import { css, keyframes } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

export const backgroundImageCover = css`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const flexCenter = css`
  justify-content: center;
  align-items: center;
`;

export const singleLine = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const blinkAnimation = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fillAnimation = keyframes`
  from {
    fill: ${getThemeColor('accent')};
  }
  to {
    fill: ${getThemeColor('foreground')}
  }
`;
